import React from "react";

export const CATEGORIES = [
  { value: "banka", label: "Banka Taklidi", color: "text-red-600" },
  { value: "kargo", label: "Kargo / Teslimat", color: "text-orange-600" },
  { value: "bahis", label: "Bahis / Yatırım", color: "text-purple-600" },
  { value: "icra", label: "Asılsız İcra", color: "text-amber-600" },
  { value: "telesatis", label: "Arama / Telesatış", color: "text-blue-600" },
  { value: "sahtekarlik", label: "Genel Dolandırıcılık", color: "text-red-600" },
  { value: "guvenli", label: "Güvenli / Bilinen", color: "text-emerald-600" },
];

export function categoryLabel(v) {
  return CATEGORIES.find((c) => c.value === v)?.label || v;
}

const STATUS = {
  danger: { label: "YÜKSEK RİSKLİ", bg: "bg-red-50 dark:bg-red-950/40", text: "text-red-600 dark:text-red-400", ring: "text-red-500" },
  warning: { label: "ŞÜPHELİ", bg: "bg-amber-50 dark:bg-amber-950/40", text: "text-amber-600 dark:text-amber-400", ring: "text-amber-500" },
  safe: { label: "GÜVENLİ", bg: "bg-emerald-50 dark:bg-emerald-950/40", text: "text-emerald-600 dark:text-emerald-400", ring: "text-emerald-500" },
  unknown: { label: "VERİ YOK", bg: "bg-slate-100 dark:bg-slate-800", text: "text-slate-500", ring: "text-slate-300" },
};

export function statusMeta(s) {
  return STATUS[s] || STATUS.unknown;
}

export function RiskGauge({ score = 0, status = "unknown" }) {
  const meta = statusMeta(status);
  const r = 52;
  const c = 2 * Math.PI * r;
  const off = c - (score / 100) * c;
  return (
    <div className="relative h-36 w-36" data-testid="risk-gauge">
      <svg viewBox="0 0 120 120" className="h-full w-full -rotate-90">
        <circle cx="60" cy="60" r={r} fill="none" strokeWidth="12" className="stroke-slate-100 dark:stroke-slate-800" />
        <circle
          cx="60" cy="60" r={r} fill="none" strokeWidth="12" strokeLinecap="round"
          className={meta.ring}
          stroke="currentColor"
          strokeDasharray={c}
          strokeDashoffset={off}
          style={{ transition: "stroke-dashoffset 0.8s ease" }}
        />
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <div>
          <div className={`text-3xl font-extrabold font-display ${meta.text}`}>{score}</div>
          <div className="text-[10px] font-bold tracking-wider text-slate-400">RİSK SKORU</div>
        </div>
      </div>
    </div>
  );
}
